import * as React from 'react'

type SidebarForumIconProps = React.SVGProps<SVGSVGElement> & {
  active?: boolean
  size?: number | string
}

export const SidebarForumIcon = React.forwardRef<SVGSVGElement, SidebarForumIconProps>(
  ({ active = false, size = 24, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g transform="translate(-6.5, -7) scale(1.35)">
          <path
            d="M10 26.2744V10.5217C10 10.2336 10.2336 10 10.5217 10H26.5C26.7882 10 27.0217 10.2336 27.0217 10.5217V16.2609C27.0217 19.7187 24.2186 22.5217 20.7609 22.5217H14.9233C14.6518 22.5217 14.3911 22.6275 14.1963 22.8166L10.4426 26.4615C10.2772 26.6222 10 26.5049 10 26.2744Z"
            fill={active ? '#0B2948' : '#FBFBFB'}
          />
          <path
            d="M21.3478 23.3043H15.4814C15.2996 23.3043 15.1522 23.4517 15.1522 23.6335C15.1522 25.3607 16.5523 26.7609 18.2795 26.7609H26.3895C26.6688 26.7609 26.9365 26.8728 27.1326 27.0717L30.9447 30.9383C31.1085 31.1044 31.3913 30.9884 31.3913 30.7551V13.5217C31.3913 13.2336 31.1577 13 30.8696 13H27.8696V16.7826C27.8696 20.3845 24.9497 23.3043 21.3478 23.3043Z"
            fill="#64C6DA"
          />{' '}
        </g>
      </svg>
    )
  },
)

SidebarForumIcon.displayName = 'SidebarForumIcon'
